"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactInfo = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _common = require("b2b-components/theme/components/CMS/common");
var _Icon = require("b2b-components/theme/components/Icon");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
require("./ContactInfo.scss");
const ContactInfo = _ref => {
  let {
    topHtmlText,
    title,
    imageUrl,
    name,
    jobTitle,
    email,
    phone,
    bottomHtmlText,
    isHorizontal,
    size = _common.CMS_SIZING.size100,
    className,
    dataAttributes
  } = _ref;
  if (!(bottomHtmlText || email || imageUrl || jobTitle || name || phone || topHtmlText)) {
    return null;
  }
  const rootClassName = (0, _classnames.default)('cds-cms-ContactInfo', `cds-cms-ContactInfo--${size}`, {
    'cds-cms-ContactInfo--Horizontal': isHorizontal
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), title, topHtmlText && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-ContactInfo-RichText cds-cms-RichTextEditor",
    dangerouslySetInnerHTML: {
      __html: topHtmlText
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-ContactInfo-ContactWrapper"
  }, imageUrl && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-ContactInfo-ImageWrapper"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: typeof name === 'string' ? name : '',
    className: "cds-cms-ContactInfo-Image",
    src: imageUrl
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-ContactInfo-ContactDetailsWrapper"
  }, (name || jobTitle) && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-ContactInfo-NameWrapper"
  }, name && /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-cms-ContactInfo-Name"
  }, name), jobTitle && /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-cms-ContactInfo-JobTitle"
  }, jobTitle)), phone && /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-cms-ContactInfo-IconWithText"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-cms-ContactInfo-Icon",
    name: _Icon.ICON_NAME.phone,
    size: _Icon.ICON_SIZE.medium
  }), /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-cms-ContactInfo-Phone",
    href: `tel:${phone}`
  }, phone)), email && /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-cms-ContactInfo-IconWithText"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-cms-ContactInfo-Icon",
    name: _Icon.ICON_NAME.mail,
    size: _Icon.ICON_SIZE.medium
  }), /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-cms-ContactInfo-Email",
    href: `mailto:${email}`
  }, email)))), bottomHtmlText && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-ContactInfo-RichText cds-cms-RichTextEditor",
    dangerouslySetInnerHTML: {
      __html: bottomHtmlText
    }
  })));
};
exports.ContactInfo = ContactInfo;
//# sourceMappingURL=ContactInfo.js.map